/** Shared CRM lead search — used by filter bar and Cmd+K palette. */

export const CRM_SEARCH_FIELDS = [
  "name",
  "business_name",
  "mobile",
  "email",
  "address",
  "city",
  "pincode",
  "source",
  "enquiry_source",
  "came_from",
  "parent_name",
  "extra",
  "remark",
  "staff_name",
  "type_customer",
  "borrowAmount",
];

export function getLeadSearchHaystack(lead) {
  const assignNames = (lead.AssignLeads || [])
    .map((a) => a.staff_name)
    .filter(Boolean)
    .join(" ");
  return [
    ...CRM_SEARCH_FIELDS.map((f) => lead[f]),
    assignNames,
    lead.createdAt,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function matchLeadSearch(lead, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return true;
  return getLeadSearchHaystack(lead).includes(q);
}

export function searchLeads(leads, query, limit = 20) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return [];
  return (leads || [])
    .filter((lead) => matchLeadSearch(lead, q))
    .slice(0, limit);
}

export function getLeadDisplayName(lead) {
  const name = lead?.name?.trim();
  const business = lead?.business_name?.trim();
  return name || business || "Unknown lead";
}

export function getLeadSubtitle(lead) {
  const parts = [
    lead?.mobile,
    lead?.email,
    lead?.source || lead?.enquiry_source,
    lead?.extra,
  ].filter(Boolean);
  return parts.join(" · ");
}
